/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente WrapFilter
 */
export const WrapFilter = styled.div`
  nav {
    margin: 0;
    button {
      font-size: 14px;
      line-height: 16px;
      color: #5e6366;
    }
  }
  .filter-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .filter-field {
      width: 25%;
      margin-right: 30px;
      &.filter-value {
        width: 40%;
      }
      .values {
        display: none;
      }
    }
    @media (max-width: 768px) {
      align-items: unset;
      justify-content: unset;
      height: calc(100% - 100px);
      flex-wrap: nowrap;
      overflow-x: hidden;
      align-self: stretch;
      flex: 1 0 auto;
      border-bottom: 1px solid #e6e6e6;
      .filter-field {
        flex: 0 0 100%;
        height: 100%;
        align-self: stretch;
        /* overflow: auto; */
        display: flex;
        flex-direction: column;
        .values {
          position: relative;
          padding: 8px 50px 6px 23px;
          width: 100%;
          max-height: 45.26px;
          background: #f2f1f1;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          overflow: hidden;
          transition: max-height 500ms;
          &.expanded {
            overflow: auto;
            max-height: 197px;
            .expand-button {
              transform: rotate(180deg);
            }
          }
          .expand-button {
            position: absolute;
            right: 30px;
            top: 13px;
            padding: 0;
            border: none;
            color: #3c71dd;
            transform: rotate(0deg);
            transition: transform 300ms;
            background: transparent;
          }
          .item-value {
            margin: 6px 4px;
            width: 76.53px;
            height: 18.52px;
            border-radius: 10px;
            background: #32b797;
            padding: 0 5px;
            text-align: center;
            p {
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 10px;
              line-height: 16px;
              text-align: center;
              color: #ffffff;
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              margin: 2px 0 0 0;
            }
            &.red {
              background: #c24938;
            }
          }
        }
        .field {
          flex: 1;
          overflow: auto;
          padding: 10px;
        }
      }
      .MuiButton-root {
        display: none;
      }
    }
  }
  .MuiButton-root {
    width: 85.43px;
    height: 24px;
    padding: 4px;
    background-color: #3c71dd;
    border-radius: 3px;
    transition: opacity 300ms;
    &:disabled {
      background-color: #aeaeae;
    }
    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      text-transform: capitalize;
    }
    &:hover {
      background-color: #3c71dd;
      opacity: 0.7;
    }
    @media (max-width: 768px) {
      width: calc(100% - 37px);
      height: 32px;
      margin-top: 17px;
    }
  }
  .text-field {
    font-size: 14px;
    line-height: 16px;
    font-family: Roboto;
    font-weight: normal;
    letter-spacing: normal;
    &::before {
      border-bottom: 0.5px solid #5e6366;
    }

    &:hover {
      &::before {
        border-bottom: 0.5px solid #000 !important;
      }
    }

    input {
      height: 18px;
      padding: 6px 5px 7px;
    }
  }
  @media (max-width: 768px) {
    position: fixed;
    width: 100%;
    height: calc(100% - 66px);
  }
`;
